import type { SVGProps } from "react";
const SvgNumber02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="41.357pt"
    height="73.909pt"
    viewBox="35.63 -519.633 41.357 73.909"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 54.822,462.355 C 54.712,462.211 54.681,462.078 54.73,461.956 C 54.778,461.833 54.898,461.784 55.088,461.809 L 73.551,464.252 C 73.868,464.294 74.137,464.217 74.356,464.02 C 74.576,463.823 74.675,463.562 74.654,463.236 L 74.809,451.83 C 74.787,451.504 74.68,451.216 74.487,450.964 C 74.295,450.713 74.04,450.566 73.723,450.524 L 37.558,445.739 C 36.86,445.647 36.461,445.981 36.36,446.743 L 36.25,458.542 C 36.271,458.868 36.43,459.373 36.727,460.058 L 41.961,467.335 C 47.644,475.124 51.536,480.836 53.637,484.471 C 55.306,487.467 56.514,490.161 57.263,492.552 C 58.012,494.943 58.247,497.185 57.97,499.279 C 57.626,501.88 56.47,503.051 54.503,502.791 C 53.488,502.656 52.659,502.095 52.015,501.106 C 51.371,500.117 51.078,498.916 51.136,497.503 L 51.202,493.348 C 51.181,493.022 51.074,492.734 50.881,492.482 C 50.688,492.231 50.433,492.084 50.116,492.042 L 36.792,490.279 C 36.475,490.237 36.207,490.315 35.987,490.512 C 35.767,490.709 35.668,490.97 35.689,491.296 L 35.63,496.13 C 35.948,501.53 37.891,506.112 41.46,509.877 C 45.029,513.642 49.605,515.893 55.188,516.632 C 60.074,517.278 64.167,516.351 67.467,513.85 C 70.768,511.35 72.738,507.689 73.376,502.867 C 73.46,502.232 73.531,501.209 73.589,499.796 C 73.599,496.311 73.111,493.051 72.125,490.016 C 71.139,486.98 69.532,483.636 67.304,479.985 C 65.554,477.106 62.569,472.838 58.347,467.179 L 54.822,462.355 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 57,465.157 C 56.89,465.013 56.859,464.88 56.908,464.758 C 56.956,464.635 57.076,464.586 57.266,464.611 L 75.729,467.054 C 76.046,467.096 76.315,467.019 76.534,466.822 C 76.754,466.625 76.853,466.364 76.832,466.038 L 76.987,454.632 C 76.965,454.306 76.858,454.018 76.665,453.766 C 76.473,453.515 76.218,453.368 75.901,453.326 L 39.736,448.541 C 39.038,448.449 38.639,448.783 38.538,449.545 L 38.428,461.344 C 38.449,461.67 38.608,462.175 38.905,462.86 L 44.139,470.137 C 49.822,477.926 53.714,483.638 55.815,487.273 C 57.484,490.269 58.692,492.963 59.441,495.354 C 60.19,497.745 60.425,499.987 60.148,502.081 C 59.804,504.682 58.648,505.853 56.681,505.593 C 55.666,505.458 54.837,504.897 54.193,503.908 C 53.549,502.919 53.256,501.718 53.314,500.305 L 53.38,496.15 C 53.359,495.824 53.252,495.536 53.059,495.284 C 52.866,495.033 52.611,494.886 52.294,494.844 L 38.97,493.081 C 38.653,493.039 38.385,493.117 38.165,493.314 C 37.945,493.511 37.846,493.772 37.867,494.098 L 37.808,498.932 C 38.126,504.332 40.069,508.914 43.638,512.679 C 47.207,516.444 51.783,518.695 57.366,519.434 C 62.252,520.08 66.345,519.153 69.645,516.652 C 72.946,514.152 74.916,510.491 75.554,505.669 C 75.638,505.034 75.709,504.011 75.767,502.598 C 75.777,499.113 75.289,495.853 74.303,492.818 C 73.317,489.782 71.71,486.438 69.482,482.787 C 67.732,479.908 64.747,475.64 60.525,469.981 L 57,465.157 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber02;
